import * as React from 'react'

export class AdvancedAlertModalSvg extends React.Component {
  
  render() {
    return (
      <svg width="447px" height="296px" viewBox="0 0 447 296" version="1.1">
        <defs/>
        <g id="alet-how-to-image" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Page-1" transform="translate(3.000000, 4.000000)">
            <g id="Group-27" transform="translate(0.000000, 6.594000)">
              <polygon id="Stroke-1" stroke="#CEE9F2" points="0.5 184.909 256 184.909 256 0.157 0.5 0.157"/>
              <g id="Group-12" transform="translate(11.000000, 123.000000)">
                <polygon id="Fill-3" fill="#FBFDFE" points="7.781 42.577 18.874 42.577 18.874 27.786 7.781 27.786"/>
                <polygon id="Fill-4" fill="#FBFDFE" points="29.967 42.577 41.06 42.577 41.06 17.926 29.967 17.926"/>
                <polygon id="Fill-5" fill="#FBFDFE" points="0.632 10.284 59.301 10.284 59.301 0.917 0.632 0.917"/>
                <path
                  d="M0.385,10.531 L59.547,10.531 L59.547,0.671 L0.385,0.671 L0.385,10.531 Z M0.879,10.038
                    L59.055,10.038 L59.055,1.164 L0.879,1.164 L0.879,10.038 Z"
                  id="Fill-6"
                  fill="#CEE9F2"
                />
                <path
                  d="M0.385,49.972 L59.547,49.972 L59.547,0.671 L0.385,0.671 L0.385,49.972 Z M1.372,48.986
                    L58.562,48.986 L58.562,1.656 L1.372,1.656 L1.372,48.986 Z"
                  id="Fill-7"
                  fill="#CEE9F2"
                />
                <path
                  d="M7.288,42.577 L8.274,42.577 L8.274,27.786 L7.288,27.786 L7.288,42.577 Z M7.781,43.07
                    L18.874,43.07 L18.874,42.084 L7.781,42.084 L7.781,43.07 Z M18.381,42.577 L19.367,42.577
                    L19.367,27.786 L18.381,27.786 L18.381,42.577 Z M7.781,28.279 L18.874,28.279 L18.874,27.293
                    L7.781,27.293 L7.781,28.279 Z M7.288,43.07 L7.781,43.07 L7.781,42.577 L7.288,42.577
                    L7.288,43.07 Z M18.874,43.07 L19.367,43.07 L19.367,42.577 L18.874,42.577 L18.874,43.07 Z
                    M18.874,27.786 L19.367,27.786 L19.367,27.293 L18.874,27.293 L18.874,27.786 Z M7.288,27.787
                    L7.781,27.787 L7.781,27.294 L7.288,27.294 L7.288,27.787 Z"
                  id="Fill-8"
                  fill="#CEE9F2"
                />
                <path
                  d="M18.381,42.576 L19.367,42.576 L19.367,32.716 L18.381,32.716 L18.381,42.576 Z M18.874,43.07
                    L29.967,43.07 L29.967,42.084 L18.874,42.084 L18.874,43.07 Z M29.474,42.577 L30.46,42.577
                    L30.46,32.717 L29.474,32.717 L29.474,42.577 Z M18.874,33.21 L29.967,33.21 L29.967,32.224
                    L18.874,32.224 L18.874,33.21 Z M18.381,43.07 L18.874,43.07 L18.874,42.577 L18.381,42.577
                    L18.381,43.07 Z M29.967,43.07 L30.46,43.07 L30.46,42.577 L29.967,42.577 L29.967,43.07 Z
                    M29.967,32.716 L30.46,32.716 L30.46,32.223 L29.967,32.223 L29.967,32.716 Z M18.381,32.716
                    L18.874,32.716 L18.874,32.223 L18.381,32.223 L18.381,32.716 Z"
                  id="Fill-9"
                  fill="#CEE9F2"
                />
                <path
                  d="M29.473,42.577 L30.459,42.577 L30.459,17.926 L29.473,17.926 L29.473,42.577 Z M29.967,43.07
                    L41.06,43.07 L41.06,42.084 L29.967,42.084 L29.967,43.07 Z M40.566,42.577 L41.552,42.577
                    L41.552,17.926 L40.566,17.926 L40.566,42.577 Z M29.967,18.419 L41.06,18.419 L41.06,17.433
                    L29.967,17.433 L29.967,18.419 Z M29.474,43.07 L29.967,43.07 L29.967,42.577 L29.474,42.577
                    L29.474,43.07 Z M41.06,43.07 L41.553,43.07 L41.553,42.577 L41.06,42.577 L41.06,43.07 Z
                    M41.06,17.926 L41.553,17.926 L41.553,17.433 L41.06,17.433 L41.06,17.926 Z M29.474,17.926
                    L29.967,17.926 L29.967,17.433 L29.474,17.433 L29.474,17.926 Z"
                  id="Fill-10"
                  fill="#CEE9F2"
                />
                <path
                  d="M40.567,42.577 L41.553,42.577 L41.553,22.856 L40.567,22.856 L40.567,42.577 Z M41.059,43.07
                    L52.152,43.07 L52.152,42.084 L41.059,42.084 L41.059,43.07 Z M51.659,42.577 L52.645,42.577
                    L52.645,22.856 L51.659,22.856 L51.659,42.577 Z M41.06,23.349 L52.153,23.349 L52.153,22.363
                    L41.06,22.363 L41.06,23.349 Z M40.567,43.07 L41.06,43.07 L41.06,42.577 L40.567,42.577
                    L40.567,43.07 Z M52.152,43.07 L52.645,43.07 L52.645,42.577 L52.152,42.577 L52.152,43.07 Z
                     M52.152,22.856 L52.645,22.856 L52.645,22.363 L52.152,22.363 L52.152,22.856 Z M40.567,22.856
                     L41.06,22.856 L41.06,22.363 L40.567,22.363 L40.567,22.856 Z"
                  id="Fill-11"
                  fill="#CEE9F2"
                />
              </g>
              <g id="Group-22" transform="translate(80.000000, 123.000000)">
                <polygon id="Fill-13" fill="#CEE9F2" points="16.481 42.576 17.467 42.576 17.467 32.716 16.481 32.716"/>
                <polygon id="Fill-14" fill="#CEE9F2" points="7.803 42.577 8.789 42.577 8.789 27.786 7.803 27.786"/>
                <polygon id="Fill-15" fill="#CEE9F2" points="25.157 42.577 26.143 42.577 26.143 22.856 25.157 22.856"/>
                <polygon id="Fill-16" fill="#CEE9F2" points="33.834 42.577 34.82 42.577 34.82 27.786 33.834 27.786"/>
                <polygon id="Fill-17" fill="#CEE9F2" points="42.511 42.576 43.497 42.576 43.497 32.716 42.511 32.716"/>
                <polygon id="Fill-18" fill="#CEE9F2" points="51.188 42.577 52.174 42.577 52.174 17.926 51.188 17.926"/>
                <polygon id="Fill-19" fill="#FBFDFE" points="0.654 10.284 59.323 10.284 59.323 0.917 0.654 0.917"/>
                <path
                  d="M0.408,10.531 L59.57,10.531 L59.57,0.671 L0.408,0.671 L0.408,10.531 Z M0.901,10.038
                    L59.077,10.038 L59.077,1.164 L0.901,1.164 L0.901,10.038 Z"
                  id="Fill-20"
                  fill="#CEE9F2"
                />
                <path
                  d="M0.408,49.972 L59.57,49.972 L59.57,0.671 L0.408,0.671 L0.408,49.972 Z M1.394,48.986
                    L58.583,48.986 L58.583,1.656 L1.394,1.656 L1.394,48.986 Z"
                  id="Fill-21"
                  fill="#CEE9F2"
                />
              </g>
              <g id="Group-26" transform="translate(11.000000, 10.000000)">
                <polygon id="Fill-23" fill="#FFFFFF" points="0.643 99.334 236.785 99.334 236.785 0.889 0.643 0.889"/>
                <polygon
                  id="Stroke-24"
                  stroke="#CEE9F2"
                  points="0.643 99.334 236.785 99.334 236.785 0.889 0.643 0.889"
                />
                <path
                  d="M154.0737,90.0279 C172.2827,90.0279 181.3677,76.7619 190.1667,63.9889 C199.0277,51.1259
                    207.6027,38.7549 224.7937,38.7549 L224.7937,36.7039 C206.5847,36.7039 197.4997,49.9689
                    188.7017,62.7419 C179.8407,75.6059 171.2657,87.9769 154.0737,87.9769 L154.0737,90.0279 Z
                    M83.3547,38.7549 C100.5057,38.7549 109.0797,51.1249 117.9507,63.9899 C126.7607,76.7629
                    135.8657,90.0279 154.0737,90.0279 L154.0737,87.9769 C136.8817,87.9769 128.2857,75.6049
                    119.4157,62.7419 C110.6077,49.9699 101.5227,36.7039 83.3547,36.7039 L83.3547,38.7549 Z
                    M12.6347,90.0279 C30.8027,90.0279 39.8877,76.7619 48.6957,63.9899 C57.5667,51.1269
                    66.1617,38.7549 83.3547,38.7549 L83.3547,36.7039 C65.1457,36.7039 56.0407,49.9679
                    47.2317,62.7419 C38.3597,75.6069 29.7857,87.9769 12.6347,87.9769 L12.6347,90.0279 Z"
                  id="Fill-25"
                  fill="#C1E1EA"
                />
              </g>
            </g>
            <polygon id="Fill-28" fill="#FFFFFF" points="163.5 287.594 440.499 287.594 440.499 76.75 163.5 76.75"/>
            <g id="Group-48" transform="translate(163.000000, 76.594000)">
              <polygon
                id="Stroke-29"
                stroke="#CEE9F2"
                strokeWidth="2"
                points="0.5 211 277.5 211 277.5 0.156 0.5 0.156"
              />
              <path
                d="M51.5,157.6564 L19.5,157.6564 C18.396,157.6564 17.5,156.7604 17.5,155.6564 L17.5,148.6564
                  C17.5,147.5524 18.396,146.6564 19.5,146.6564 L51.5,146.6564 C52.604,146.6564 53.5,147.5524
                  53.5,148.6564 L53.5,155.6564 C53.5,156.7604 52.604,157.6564 51.5,157.6564"
                id="Fill-31"
                fill="#FFFFFF"
              />
              <path
                d="M51.5,157.6564 L19.5,157.6564 C18.396,157.6564 17.5,156.7604 17.5,155.6564 L17.5,148.6564
                  C17.5,147.5524 18.396,146.6564 19.5,146.6564 L51.5,146.6564 C52.604,146.6564 53.5,147.5524
                  53.5,148.6564 L53.5,155.6564 C53.5,156.7604 52.604,157.6564 51.5,157.6564 Z"
                id="Stroke-32"
                stroke="#CEE9F2"
                strokeWidth="2"
              />
              <path
                d="M95.75,157.6564 L63.75,157.6564 C62.646,157.6564 61.75,156.7604 61.75,155.6564 L61.75,148.6564
                  C61.75,147.5524 62.646,146.6564 63.75,146.6564 L95.75,146.6564 C96.854,146.6564 97.75,147.5524
                  97.75,148.6564 L97.75,155.6564 C97.75,156.7604 96.854,157.6564 95.75,157.6564"
                id="Fill-33"
                fill="#FFFFFF"
              />
              <path
                d="M95.75,157.6564 L63.75,157.6564 C62.646,157.6564 61.75,156.7604 61.75,155.6564 L61.75,148.6564
                  C61.75,147.5524 62.646,146.6564 63.75,146.6564 L95.75,146.6564 C96.854,146.6564 97.75,147.5524
                  97.75,148.6564 L97.75,155.6564 C97.75,156.7604 96.854,157.6564 95.75,157.6564 Z"
                id="Stroke-34"
                stroke="#CEE9F2"
                strokeWidth="2"
              />
              <path
                d="M140,157.6564 L108,157.6564 C106.896,157.6564 106,156.7604 106,155.6564 L106,148.6564
                  C106,147.5524 106.896,146.6564 108,146.6564 L140,146.6564 C141.104,146.6564 142,147.5524
                  142,148.6564 L142,155.6564 C142,156.7604 141.104,157.6564 140,157.6564"
                id="Fill-35"
                fill="#FFFFFF"
              />
              <path
                d="M140,157.6564 L108,157.6564 C106.896,157.6564 106,156.7604 106,155.6564 L106,148.6564
                   C106,147.5524 106.896,146.6564 108,146.6564 L140,146.6564 C141.104,146.6564 142,147.5524
                   142,148.6564 L142,155.6564 C142,156.7604 141.104,157.6564 140,157.6564 Z"
                id="Stroke-36"
                stroke="#CEE9F2"
                strokeWidth="2"
              />
              <path
                d="M24.2417,12.7413 C24.2417,14.9603 22.4427,16.7593 20.2237,16.7593 C18.0047,16.7593 16.2057,14.9603
                   16.2057,12.7413 C16.2057,10.5223 18.0047,8.7233 20.2237,8.7233 C22.4427,8.7233 24.2417,10.5223
                   24.2417,12.7413"
                id="Fill-37"
                fill="#CEE9F2"
              />
              <path
                d="M38.7056,12.7413 C38.7056,14.9603 36.9066,16.7593 34.6876,16.7593 C32.4686,16.7593
                  30.6696,14.9603 30.6696,12.7413 C30.6696,10.5223 32.4686,8.7233 34.6876,8.7233 C36.9066,8.7233
                  38.7056,10.5223 38.7056,12.7413"
                id="Fill-38"
                fill="#CEE9F2"
              />
              <path
                d="M53.1694,12.7413 C53.1694,14.9603 51.3704,16.7593 49.1514,16.7593 C46.9324,16.7593 45.1334,14.9603
                  45.1334,12.7413 C45.1334,10.5223 46.9324,8.7233 49.1514,8.7233 C51.3704,8.7233 53.1694,10.5223
                  53.1694,12.7413"
                id="Fill-39"
                fill="#CEE9F2"
              />
              <g id="Group-42" transform="translate(0.000000, 25.000000)">
                <path d="M0.9673,0.3815 L277.0333,0.3815" id="Fill-40" fill="#FFFFFF"/>
                <path d="M0.9673,0.3815 L277.0333,0.3815" id="Stroke-41" stroke="#CEE9F2" strokeWidth="2"/>
              </g>
              <polygon id="Fill-43" fill="#FBFDFE" points="15.5 130.656 266.5 130.656 266.5 35.656 15.5 35.656"/>
              <path
                d="M13.508,131.83 L266.077,131.83 L266.077,37.756 L13.508,37.756 L13.508,131.83 Z M15.451,129.949
                  L264.135,129.949 L264.135,39.637 L15.451,39.637 L15.451,129.949 Z"
                id="Fill-44"
                fill="#CEE9F2"
              />
              <path
                d="M177.0303,118.6603 C196.2063,118.6603 205.7733,106.4903 215.0403,94.7723 C224.3713,82.9723
                  233.4013,71.6223 251.5063,71.6223 L251.5063,69.7413 C232.3303,69.7413 222.7623,81.9113
                  213.4973,93.6293 C204.1663,105.4303 195.1353,116.7793 177.0303,116.7793 L177.0303,118.6603 Z
                  M102.5543,71.6223 C120.6173,71.6223 129.6463,82.9713 138.9893,94.7733 C148.2663,106.4913
                  157.8553,118.6603 177.0303,118.6603 L177.0303,116.7793 C158.9253,116.7793 149.8733,105.4293
                  140.5313,93.6283 C131.2563,81.9113 121.6883,69.7413 102.5543,69.7413 L102.5543,71.6223 Z
                  M28.0793,118.6603 C47.2133,118.6603 56.7803,106.4903 66.0553,94.7733 C75.3983,82.9723 84.4503,71.6223
                  102.5543,71.6223 L102.5543,69.7413 C83.3803,69.7413 73.7913,81.9103 64.5143,93.6283 C55.1713,105.4303
                  46.1413,116.7793 28.0793,116.7793 L28.0793,118.6603 Z"
                id="Fill-45"
                fill="#CEE9F2"
              />
              <path
                d="M112.5,199.6564 L19.5,199.6564 C18.396,199.6564 17.5,198.7604 17.5,197.6564 L17.5,172.6564
                  C17.5,171.5524 18.396,170.6564 19.5,170.6564 L112.5,170.6564 C113.604,170.6564 114.5,171.5524
                  114.5,172.6564 L114.5,197.6564 C114.5,198.7604 113.604,199.6564 112.5,199.6564"
                id="Fill-46"
                fill="#29ABE2"
              />
              <path
                d="M36.5825,190.1564 C36.8445,189.8074 36.9995,189.3754 36.9995,188.9064 L36.9995,185.1564
                  C36.9995,183.1324 38.2075,181.3204 40.0775,180.5414 C40.2315,180.4764 40.3335,180.3244
                  40.3335,180.1564 C40.3335,179.2374 41.0815,178.4894 41.9995,178.4894 C42.9185,178.4894
                  43.6665,179.2374 43.6665,180.1564 C43.6665,180.3244 43.7675,180.4764 43.9225,180.5414
                  C45.7925,181.3214 46.9995,183.1334 46.9995,185.1564 L46.9995,188.9064 C46.9995,189.3754
                  47.1555,189.8074 47.4175,190.1564 L36.5825,190.1564 Z M41.9995,191.8234 C41.4575,191.8234
                  40.9995,191.4734 40.8265,190.9894 L43.1735,190.9894 C43.0005,191.4734 42.5425,191.8234
                  41.9995,191.8234 Z M49.0835,190.1564 C48.3945,190.1564 47.8335,189.5954 47.8335,188.9064
                  L47.8335,185.1564 C47.8335,182.8844 46.5275,180.8404 44.4845,179.8794 C44.3465,178.6304
                  43.2845,177.6564 41.9995,177.6564 C40.7155,177.6564 39.6535,178.6304 39.5155,179.8794
                  C37.4725,180.8384 36.1665,182.8834 36.1665,185.1564 L36.1665,188.9064 C36.1665,189.5954
                  35.6055,190.1564 34.9165,190.1564 C34.6865,190.1564 34.4995,190.3434 34.4995,190.5734
                  C34.4995,190.8034 34.6865,190.9894 34.9165,190.9894 L39.9585,190.9894 C40.1525,191.9394
                  40.9945,192.6564 41.9995,192.6564 C43.0055,192.6564 43.8475,191.9394 44.0405,190.9894
                  L49.0835,190.9894 C49.3135,190.9894 49.4995,190.8034 49.4995,190.5734 C49.4995,190.3434
                  49.3135,190.1564 49.0835,190.1564 Z"
                id="Fill-47"
                fill="#FFFFFF"
              />
            </g>
            <text id="+" fontFamily="MyriadPro-Semibold, Myriad Pro" fontSize="14" fontWeight="500" fill="#FFFFFF">
              <tspan x="187.5" y="266.583272">+</tspan>
            </text>
            <text id="Add-alert" fontFamily="OpenSans, Open Sans" fontSize="11" fontWeight="normal" fill="#FFFFFF">
              <tspan x="217.5" y="265.27022">Add</tspan>
              <tspan x="240.799805" y="265.27022" letterSpacing="-0.0066">a</tspan>
              <tspan x="246.91088" y="265.27022">lert</tspan>
            </text>
            <g id="Group-65" transform="translate(203.000000, 0.594000)">
              <path
                d="M186.5,233.6564 L154.5,233.6564 C153.396,233.6564 152.5,232.7604 152.5,231.6564 L152.5,224.6564
                  C152.5,223.5524 153.396,222.6564 154.5,222.6564 L186.5,222.6564 C187.604,222.6564 188.5,223.5524
                  188.5,224.6564 L188.5,231.6564 C188.5,232.7604 187.604,233.6564 186.5,233.6564"
                id="Fill-49"
                fill="#FFFFFF"
              />
              <path
                d="M186.5,233.6564 L154.5,233.6564 C153.396,233.6564 152.5,232.7604 152.5,231.6564 L152.5,224.6564
                  C152.5,223.5524 153.396,222.6564 154.5,222.6564 L186.5,222.6564 C187.604,222.6564 188.5,223.5524
                  188.5,224.6564 L188.5,231.6564 C188.5,232.7604 187.604,233.6564 186.5,233.6564 Z"
                id="Stroke-51"
                stroke="#CEE9F2"
                strokeWidth="2"
              />
              <path
                d="M143.25,233.6564 L111.25,233.6564 C110.146,233.6564 109.25,232.7604 109.25,231.6564
                  L109.25,224.6564 C109.25,223.5524 110.146,222.6564 111.25,222.6564 L143.25,222.6564
                  C144.354,222.6564 145.25,223.5524 145.25,224.6564 L145.25,231.6564 C145.25,232.7604 144.354,233.6564
                   143.25,233.6564"
                id="Fill-53"
                fill="#29ABE2"
              />
              <path
                d="M67.5,33.6564 C67.5,52.1574 52.502,67.1564 34,67.1564 C15.499,67.1564 0.5,52.1574 0.5,33.6564
                  C0.5,15.1554 15.499,0.1564 34,0.1564 C52.502,0.1564 67.5,15.1554 67.5,33.6564 Z"
                id="Stroke-57"
                stroke="#29ABE2"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeDasharray="3.035,5.058"
              />
              <path
                d="M36,27.6564 C36,28.7604 35.104,29.6564 34,29.6564 C32.896,29.6564 32,28.7604 32,27.6564
                  C32,26.5524 32.896,25.6564 34,25.6564 C35.104,25.6564 36,26.5524 36,27.6564"
                id="Fill-59"
                fill="#506773"
              />
              <path
                d="M36,34.6564 C36,35.7604 35.104,36.6564 34,36.6564 C32.896,36.6564 32,35.7604 32,34.6564
                  C32,33.5524 32.896,32.6564 34,32.6564 C35.104,32.6564 36,33.5524 36,34.6564"
                id="Fill-61"
                fill="#506773"
              />
              <path
                d="M36,41.6564 C36,42.7604 35.104,43.6564 34,43.6564 C32.896,43.6564 32,42.7604 32,41.6564
                  C32,40.5524 32.896,39.6564 34,39.6564 C35.104,39.6564 36,40.5524 36,41.6564"
                id="Fill-63"
                fill="#506773"
              />
            </g>
          </g>
        </g>
      </svg>
    )
  }
}
